import { iBookingConfirmationTemplate } from "@/@sdk/brands/brand-model";
import {
  DEFAULT_BOOKING_CONFIRMATION_CHECK_IN_TIMES,
  DEFAULT_BOOKING_CONFIRMATION_GREETINGS_TEMPLATE,
  DEFAULT_BOOKING_CONFIRMATION_HOW_TO_PAY,
  DEFAULT_BOOKING_CONFIRMATION_IMPORTANT_INFORMATION,
  DEFAULT_BOOKING_CONFIRMATION_OTHER_INFORMATION,
  DEFAULT_BOOKING_CONFIRMATION_PRICING_POLICY,
  DEFAULT_BOOKING_CONFIRMATION_TRAVEL_ADVICE,
  DEFAULT_BOOKING_EMAIL_BRAND_COLOR,
  DEFAULT_BOOKING_EMAIL_FOOTER_TEMPLATE,
  DEFAULT_BOOKING_EMAIL_HEADER_TEMPLATE,
} from "./default-booking-email-shared";

/** Generic booking confirmation email defaults using brand placeholders. */
export const defaultBookingConfirmationTemplate: iBookingConfirmationTemplate = {
  brandColor: DEFAULT_BOOKING_EMAIL_BRAND_COLOR,
  headerTemplate: DEFAULT_BOOKING_EMAIL_HEADER_TEMPLATE,
  footerTemplate: DEFAULT_BOOKING_EMAIL_FOOTER_TEMPLATE,
  defaultGreetingsTemplate: DEFAULT_BOOKING_CONFIRMATION_GREETINGS_TEMPLATE,
  pricingPolicy: DEFAULT_BOOKING_CONFIRMATION_PRICING_POLICY,
  howToPay: DEFAULT_BOOKING_CONFIRMATION_HOW_TO_PAY,
  importantInformation: DEFAULT_BOOKING_CONFIRMATION_IMPORTANT_INFORMATION,
  travelAdvice: DEFAULT_BOOKING_CONFIRMATION_TRAVEL_ADVICE,
  checkInTimes: DEFAULT_BOOKING_CONFIRMATION_CHECK_IN_TIMES,
  otherInformation: DEFAULT_BOOKING_CONFIRMATION_OTHER_INFORMATION,
};
